import { render, staticRenderFns } from "./workflowActiveSwitchElement.vue?vue&type=template&id=23f57cab&scoped=true&"
import script from "./workflowActiveSwitchElement.vue?vue&type=script&lang=js&"
export * from "./workflowActiveSwitchElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f57cab",
  null
  
)

export default component.exports